import { PageType } from '@Config/enum';
import { ICTask } from '@Helper/Interfaces';

export const getTaskColor = (task: ICTask, dealTaskList: ICTask[]) => {
  const yellow = '#FFAB00';
  const red = '#FF5630';
  const green = '#36B37E';
  if (!task.dueDate) {
    return yellow;
  } else if (task.isCompleted === true) {
    return green;
  } else {
    if (new Date() > new Date(task.dueDate)) {
      return red;
    } else {
      if (
        dealTaskList &&
        dealTaskList.filter(
          i =>
            (i.type === 'risk' || i.type === 'issue') &&
            i.isCompleted !== true &&
            i.parentId === task.id
        ).length
      ) {
        return yellow;
      } else {
        return green;
      }
    }
  }
};

export const getRaidTaskColor = (pageType: PageType, task: ICTask) => {
  const yellow = '#FFAB00';
  const red = '#FF5630';
  const green = '#36B37E';
  const gray = '#a7a5ba';
  if (pageType === PageType.RISKS) {
    return turnColor(task.riskLikelihood ?? '');
  } else if (pageType === PageType.ISSUES) {
    return turnColor(task.issueImpact ?? '');
  } else if (pageType === PageType.DECISIONS) {
    return turnColor(task.priority ?? '');
  }

  function turnColor(type: string) {
    switch (type) {
      case 'high':
        return red;
      case 'medium':
        return yellow;
      case 'low':
        return green;

      default:
        return gray;
    }
  }
};
